module.exports = __webpack_public_path__ + "img/img1.1931f77f.svg";